import React, { useEffect } from 'react';
import PersonalLoanToGoPagePartnersContent from '@/components/PersonalLoanPageContent/PersonalLoanToGoPagePartnersContent';

const PartenerLoanPage = props => {
    useEffect(() => {
      if (window?.location) {
        window.location.replace('/');
      }
    }, []);
  return (
  <></>
  );
};

export default PartenerLoanPage;
